const React = require('react');
const {
  CURRENCY_ITEMS,
  CURRENCY_USD,
} = require('../../../../../../../constants');
const withState = require('../../../../../../../utils/withState');
const Caption = require('../../../../../../dumb/Caption/C');
const Select = require('../../../../../../dumb/Select/H');
const Field = require('../../../../../../dumb/Field/E');
const TextFieldBase = require('../../../../../../dumb/TextField/Base');
const Button = require('../../../../../../dumb/Button/Accept');
const Switch = require('../../../../../../dumb/Switch/D');


module.exports = withState((setState, self, onMount) => {
  onMount(() => {
    setState({
      isPromotion: true,
      transactionOver: {
        price: 0,
        currency: CURRENCY_USD,
      },
      discount: {
        percent: 0,
        price: 0,
        currency: CURRENCY_USD,
      },
    });
  });

  return (state, props) => {
    function handleSave() {
      // TODO: Finish when API is ready
    }

    const isPromotion = state.isPromotion || false;

    return (
      <div className={'wmin270 wmax1000 ' + (props.className || '')}>
        <div className="layoutRow fhaB fvaC">
          <Caption>Promotions / Discounts</Caption>
        </div>

        <Field
          className="mt26"
          label="Do you want to set promotion/discounts to the buyers?"
        >
          <Switch
            label={isPromotion ? 'Yes' : 'No'}
            checked={isPromotion}
            onChange={(isPromotion) => {
              setState({
                isPromotion,
              });
            }}
          />
        </Field>

        <div className="layoutRow fhaS fvaC mt24">
          <div className="wmin145 f12 fw7">For transactions over</div>
          <TextFieldBase
            className="w120"
            placeholder="00.00"
            disabled={!isPromotion}
            onChange={(e) => {
              setState({
                transactionOver: {
                  ...state.ransactionOver,
                  price: Number(e.target.value),
                },
              });
            }}
          />
          <div className="w46"/>
          <div className="w120">
            <Select
              propName="id"
              propValue="id"
              value={state.transactionOver.currency}
              items={CURRENCY_ITEMS}
              onChange={(value) => {
                const {transactionOver} = state;
                transactionOver.currency = value;
                setState({transactionOver});
              }}
            />
          </div>
        </div>

        <div className="layoutRow fhaS fvaC mt24">
          <div className="wmin145 f12 fw7">Discount</div>
          <TextFieldBase
            className="w120"
            placeholder="0%"
            disabled={!isPromotion}
            onChange={(e) => {
              setState({
                discount: {
                  ...state.discount,
                  price: Number(e.target.value),
                },
              });
            }}
          />
          <div className="w46 tc f12 fw7">Or</div>
          <TextFieldBase
            className="w120"
            placeholder="00.00"
            disabled={!isPromotion}
            onChange={(e) => {
              setState({
                discount: {
                  ...state.discount,
                  price: Number(e.target.value),
                },
              });
            }}
          />
          <div className="w46"/>
          <div className="w120">
            <Select
              propName="id"
              propValue="id"
              value={state.discount.currency}
              items={CURRENCY_ITEMS}
              onChange={(currency) => {
                setState({
                  discount: {
                    ...state.discount,
                    currency,
                  },
                });
              }}
            />
          </div>
        </div>
        <div className="layoutRow fhaS fvaC mt36">
          <Button
            onClick={handleSave}
          >
            Save Settings
          </Button>
        </div>
      </div>
    );
  };
});
